const setRedirectUrl = () => {
    const params = new URLSearchParams(window.location.search)
    let redirectUrl = params.get('redirectUrl')

    if (!sessionStorage.getItem('redirectUrl') || redirectUrl) {
        sessionStorage.setItem('redirectUrl', redirectUrl)
    }
}

export default setRedirectUrl